import React from "react";
import BootstrapTable from "@partseye/react-bootstrap-table-next";
import "@partseye/react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import "@partseye/react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

function SalesHistory (props) {

    const tableColumns = [
        {"dataField": "demandYear",
            "text": props.pageText.year,
            "sort": false},
        {"dataField": "januarySales",
            "text": props.pageText.january,
            "sort": false},
        {"dataField": "februarySales",
            "text": props.pageText.february,
            "sort": false},
        {"dataField": "marchSales",
            "text": props.pageText.march,
            "sort": false},
        {"dataField": "aprilSales",
            "text": props.pageText.april,
            "sort": false},
        {"dataField": "maySales",
            "text": props.pageText.may,
            "sort": false},
        {"dataField": "juneSales",
            "text": props.pageText.june,
            "sort": false},
        {"dataField": "julySales",
            "text": props.pageText.july,
            "sort": false},
        {"dataField": "augustSales",
            "text": props.pageText.august,
            "sort": false},
        {"dataField": "septemberSales",
            "text": props.pageText.september,
            "sort": false},
        {"dataField": "octoberSales",
            "text": props.pageText.october,
            "sort": false},
        {"dataField": "novemberSales",
            "text": props.pageText.november,
            "sort": false},
        {"dataField": "decemberSales",
            "text": props.pageText.december,
            "sort": false}
    ];

    return (
        <div className="basic-info container-fluid">
            <h5 className="basic-info-title title">
                {props.pageText.salesHistoryTitle}
                <i
                    className="material-icons"
                    title={props.pageText.salesHistoryToolTip}
                >
                    help
                </i>
            </h5>
            <div className="basic-info-content">
                <BootstrapTable
                    bootstrap4
                    columns={tableColumns}
                    condensed
                    data={props.partInfo}
                    headerClasses="thead-light"
                    id="salesHistory"
                    keyField="demandYear"
                    striped
                />
                <div className="form-check-inline">
                    <label className="form-check-label">
                        <input
                            checked={!props.fullDemand}
                            className="form-check-input"
                            name="radioFilter"
                            onChange={(e) => props.onChangeFilter(e)}
                            type="radio"
                        />
                        {props.pageText.onlySalesFilter}
                    </label>
                </div>
                <div className="form-check-inline">
                    <label className="form-check-label">
                        <input
                            checked={props.fullDemand}
                            className="form-check-input"
                            name="radioFilter"
                            onChange={(e) => props.onChangeFilter(e)}
                            type="radio"
                        />
                        {props.pageText.fullDemandFilter}
                    </label>
                </div>
            </div>
        </div>
    );

}

export default SalesHistory;
